export default __webpack_public_path__ + "static/media/app-store.ef349165.jpg";